const mutations = {
    changeTime: (state,changeTime) => {
        // 变更状态
        state.time = changeTime
        //console.log(state);
        //console.log(changeTime);
      }
  }
  export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js